const indeterminateIcon = `<svg viewBox="0 0 10 10" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 5a1 1 0 0 1 1-1h8a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1Z" />
</svg>
`;
export {
  indeterminateIcon as default
};
//# sourceMappingURL=indeterminate.mjs.map
